require('isomorphic-fetch');

/**
 * GalaxyAPi
 *
 * @returns {{init: init}}
 */
const GalaxyApi = (() => {
  const postData = async (url, data) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    return response.json();
  };

  const getAvailability = async (currentMonth, currentYear, qty, eventType = '') => {
    const response = await postData('/api/availability/daterange.json', {
      currentMonth,
      currentYear,
      qty,
      eventType
    });
    return response;
  };

  const getTimeslots = async (date, visitors, extras = [], eventType = '') => {
    const response = await postData('/api/availability/timeslot.json', {
      date,
      visitors,
      extras,
      eventType
    });
    return response;
  };

  const searchTickets = async (date, timeslot, visitors, eventType = '') => {
    const response = await postData('/api/tickets/search.json', {
      date,
      timeslot,
      visitors,
      eventType
    });
    return response;
  };

  const getAddons = async (storeId) => {
    const response = await postData('/api/addon/list.json', {
      storeId
    });
    return response;
  };

  return {
    getAvailability,
    getTimeslots,
    searchTickets,
    getAddons,
  };
})();

export default GalaxyApi;
